<div class="rounded-2xl p-8">
  <div [formGroup]="subProductForm" class="flex flex-col gap-8">
    @if (errorMessage()) {
      <app-error [apiError]="errorMessage() ?? ''" />
    }

    <div>
      <h3 class="text-primary mb-5 text-xl font-bold" i18n="@@subProduct.section.attributes">Attribute Selection</h3>
      <app-attribute-selection
        [attributes]="attributes()"
        [existingCombinations]="existingCombinations"
        (onSelectionChange)="onAttributeSelectionChange($event)" />
    </div>

    <div>
      <h3 class="text-primary mb-5 text-xl font-bold" i18n="@@subProduct.section.info">Sub-Product Information</h3>
      <app-sub-product-info
        [categories]="categories()"
        [selectedValues]="selectedValues()"
        [attributes]="attributes()"
        [parentTitleEn]="parentTitleEn()"
        [parentTitleAr]="parentTitleAr()" />
    </div>

    <app-product-prices />

    <div>
      <h3 class="textTabsColor mb-3 text-sm font-bold" i18n="@@subProduct.section.images">Images</h3>
      <span class="text-red-500">*</span>

      <app-product-images
        [images]="selectedImages()"
        [errors]="imageErrors()"
        (fileSelect)="handleFileSelect($event)"
        (setPrimary)="setPrimary($event)"
        (removeImg)="removeImg($event)" />
    </div>

    <div class="flex justify-end border-t border-gray-100 pt-6">
      <button
        type="button"
        (click)="addSubProduct()"
        [disabled]="loading()"
        class="bgTabsColor cursor-pointer rounded-xl px-16 py-3.5 font-bold text-white shadow-lg transition-all active:scale-95 disabled:opacity-50">
        @if (loading()) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="me-2 inline animate-spin">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        }
        <span i18n="@@subProduct.button.add">Add</span>
      </button>
    </div>
  </div>
</div>
